import React from "react";
import { Logo } from "./Logo";

const Footer = () => (
  <footer className="border-t border-white/5 py-14" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid md:grid-cols-4 gap-10 mb-12">
        <div>
          <Logo />
          <p className="mt-4 text-sm text-white/50 max-w-xs leading-relaxed">
            Empowering the culture that keeps the world moving. Built in Atlanta for gig workers. We see you. We're building for you!
          </p>
        </div>
        {[
          { t: "Product", l: ["Features", "How it works", "App", "Float Pilot", "Security"] },
          { t: "Company", l: ["About", "Careers", "Press", "Blog"] },
          { t: "Resources", l: ["Help center", "Contact", "Privacy", "Terms"] },
        ].map((col) => (
          <div key={col.t}>
            <div className="font-mono-c text-[10px] uppercase tracking-[0.25em] text-[#00FF88] mb-4">
              {col.t}
            </div>
            <ul className="space-y-2.5">
              {col.l.map((i) => (
                <li key={i}>
                  <a
                    href={
                      i === "Features"    ? "/#features" :
                      i === "How it works"? "/#how" :
                      i === "App"         ? "/#app" :
                      i === "Security"    ? "/security" :
                      i === "Float Pilot" ? "/pilot" :
                      i === "About"       ? "/about" :
                      i === "Careers"     ? "/careers" :
                      i === "Press"       ? "/press" :
                      i === "Blog"        ? "/blog" :
                      i === "Help center" ? "/help" :
                      i === "Contact"     ? "/contact" :
                      i === "Privacy"     ? "/privacy" :
                      i === "Terms"       ? "/terms" :
                      "#"
                    }
                    className="text-sm text-white/60 hover:text-white transition-colors"
                    data-testid={`footer-link-${i.toLowerCase().replace(/\s/g,"-")}`}
                  >
                    {i}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="text-xs text-white/40 font-mono-c">
          © {new Date().getFullYear()} GigAfloat · Stay afloat between payouts.
        </div>
        <div className="flex items-center gap-5 text-xs text-white/40 font-mono-c">
          <span>Powered by your earnings</span>
          <span className="hidden md:inline">·</span>
          <span>Flexible funding for flexible work</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
